<template>
  <el-input :value="value" @input="handleInput" @focus="handleFocus" @blur="handleBlur" class="number-input"></el-input>
</template>

<script>
export default {
  props: {
    value: [String, Number]
  },
  methods: {
    handleInput (val) {
      this.$emit('input', val)
    },
    handleFocus () {
      if (this.value === 0 || this.value === '0' || this.value === '0.0' || this.value === '0.00' || this.value === '0.000') {
        this.$emit('input', '')
      }
    },
    handleBlur () {
      this.value === '' && this.$emit('input', 0)
    }
  }
}
</script>

<style lang="scss">
.number-input .el-input__inner {
  text-align: right;
}
</style>